export const bankruptcyTerminationActionTypes = {
    STORE_BANKRUPTCY_JOBS: "STORE_BANKRUPTCY_JOBS",
    STORE_BANKRUPTCY_JOB_DETAIL: "STORE_BANKRUPTCY_JOB_DETAIL",
    SET_MANUALLY_HANDLED: "SET_MANUALLY_HANDLED"
}
